import { FieldErrors } from "react-hook-form";
import styles from "./FormAddNewUser.module.css";
import { FormAddNewUser } from "@/hooks/User/useFormAddNewUser";

interface ErrorsProps {
  errors: FieldErrors<FormAddNewUser>;
}

export const Errors = ({ errors }: ErrorsProps) => {
  return (
    <div className={styles.errors}>
      {Object.values(errors).map((error, i) => (
        <p key={`${error.message}-${i}`}>{error.message}</p>
      ))}
    </div>
  );
};
